import CountUp from "./CountUp"

const Metrics = () => {
  const Data = [
    {
      title: 'Contract Research Projects',
      count: 15
    },
    {
      title: 'Years of Collective Experience',
      count: 17
    },
    {
      title: 'Students and Research Scholars Trained',
      count: 300
    },
    {
      title: 'Partnering Colleges and Institutions',
      count: 30
    },
  ]
  return (
    <div className='Metrics'>
      {Data.map((item, index) => (
        <div key={index}>
          <CountUp
            from={item.count - 15}
            to={item.count}
            direction="up"
            duration={1}
            className="CountUp"
          />
          <span className="CountUp" style={{fontSize: '3rem'}}>+</span>
          <h3>{item.title}</h3>
        </div>
      ))}
    </div>
  )
}

export default Metrics